/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeActions from "../../models/store/storeActions";
import * as storeEffects from "../../models/store/storeEffects";
import { CalendarTaskEdit, ICalendarTaskEditOwnProps, ICalendarTaskEditDispatchProps, ICalendarTaskEditStateProps } from "../../components/calendarTask/calendarTaskEdit";
import { DatabaseRecordType } from "ui/Scripts/source/models/enums";

export function mapStateToProps(applicationState: IApplicationState, ownProps: ICalendarTaskEditOwnProps): ICalendarTaskEditStateProps {
    if (!applicationState?.calendarTask?.calendarTaskEdit) {
        return {
            user: applicationState?.user,
            calendarTaskEdit: null,
        };
    }
    const calendarTaskEdit = applicationState.calendarTask.calendarTaskEdit;
    return {
        user: applicationState.user,
        calendarTaskEdit
    };
}

export function mapDispatchToProps(dispatch: storeEffects.CalendarTaskThunkDispatch): ICalendarTaskEditDispatchProps {
    return {
        loadCalendarTask: (id: string, databaseRecordType: DatabaseRecordType) => dispatch(storeEffects.getCalendarTaskEdit(id, databaseRecordType)),
        resetCalendarTask: () => dispatch(storeActions.calendarTaskEditReset())
    };
}

export default withRouter(connect<ICalendarTaskEditStateProps, ICalendarTaskEditDispatchProps, ICalendarTaskEditOwnProps>(mapStateToProps, mapDispatchToProps)(CalendarTaskEdit));